import React from "react";
import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, align = "center" }) {
    return (
        <Reveal className={`section-heading section-heading--${align}`}>
            {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
            <h2 className="section-title">{title}</h2>
            <span className="section-underline" aria-hidden="true" />
        </Reveal>
    );
}
